import React = require('react');
import { Query } from 'react-apollo';
import {
  FlowCustomSqlQuery,
  FlowCustomSqlQueryVariables
} from '../../../gen-src/queries/FlowCustomSqlQuery';
import { FlowCustomSqlQueryGql } from '../../queries/FlowCustomSqlQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { CustomSQLTable, CustomSqlTextLink } from './CustomSqlDialog';

export type FlowCustomSqlQueryWrapperProps = {
  readonly flowId: string;
  readonly outputStepId: string;
};

export function FlowCustomSqlQueryWrapper(props: FlowCustomSqlQueryWrapperProps): JSX.Element {

  return (
    <Query<FlowCustomSqlQuery, FlowCustomSqlQueryVariables>
      query={FlowCustomSqlQueryGql}
      variables={{ vizportalUrlId: props.flowId, selectedOutputStepId: props.outputStepId }}
    >
      {result => renderQueryResult(result, {
        renderData: renderCustomSqlQueries
      })}
    </Query>
  )
}

function renderCustomSqlQueries(data: FlowCustomSqlQuery): JSX.Element | null {
  const flow = data && data.flows ? data.flows[0] : null;
  const outputStep = flow && flow.outputSteps ? flow.outputSteps[0] : null;
  if (!flow || !outputStep) {
    return null;
  }

  const outputStepName = outputStep.name;
  const customSqlMap = new Map();
  outputStep.outputFields.forEach((outputField) => {
    outputField.parentFields.forEach((parentField) => {
      if (parentField.__typename === 'FlowColumnInputField') {
        const table = parentField.column?.table;
        if(table?.__typename === 'CustomSQLTable') {
          customSqlMap.set(table.id, table);
        }
      }

    })
  });

  if (customSqlMap.size === 0) {
    return null;
  }

  const customSqlTables: Array<CustomSQLTable> = Array.from(customSqlMap.values());
  return (
    <CustomSqlTextLink
      containsUnsupportedCustomSql={customSqlTables.some(t => t.isUnsupportedCustomSql ?? false)}
      customSQLTables={customSqlTables}
      contentType={flow.__typename}
      selectedDropdownName={outputStepName}
    />
  );
}
